import { render, staticRenderFns } from "./EmployeeVacationForecastWidget.vue?vue&type=template&id=10acf209&scoped=true&"
import script from "./EmployeeVacationForecastWidget.vue?vue&type=script&lang=js&"
export * from "./EmployeeVacationForecastWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10acf209",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10acf209')) {
      api.createRecord('10acf209', component.options)
    } else {
      api.reload('10acf209', component.options)
    }
    module.hot.accept("./EmployeeVacationForecastWidget.vue?vue&type=template&id=10acf209&scoped=true&", function () {
      api.rerender('10acf209', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboard/widgets/EmployeeVacationForecastWidget.vue"
export default component.exports